import * as React from 'react'
import {Location} from 'react-router-dom'
import NatCondominiumRepo from '../../condominium/repository/NatCondominiumRepo'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {Box} from '@mui/material';

import {PageTitle} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {
    HeadingAreaMessageComponentForResident
} from '../../../../components/shared/pageBaseComponents/HeadingAreaMessageComponentForResident'
import NatTokenRepo from '../../token/repository/NatTokenRepo'
import NatResidentCondominiumRegisterForm from './resident/NatResidentCondominiumRegisterForm'
import {CenterPlainLinkStyledButton} from '../../../../styledComponents/Button'
import {Nullable} from '../../../../app/TypeHelpers'
import {NatBaseResponseInterface} from '../../common/repository/NatBaseResponseInterface'
import {Messages} from '../../../../Messages'
import {NatResidentStepper} from '../../common/resident/NatResidentStepper'
import {BreakPcOnly} from '../../../../styledComponents/DisplayItem'

interface Props {
    condominiumRepo: NatCondominiumRepo
    tokenRepo: NatTokenRepo
    location: Location
}

const NatResidentCondominiumRegisterPage: React.FC<Props & ResidentWithErrorHandlingPagePropsSet> = props => {
    const onClickBackLoginLink = (): void => {
        props.navigate('/resident/login')
    }

    const onClickRegisterConfirmButton = async (
        condominiumCd: string,
        mailAddress: string,
        mailAddressConfirm: string
    ): Promise<void> => {
        await props.eventEmitter.showLoading()
        try {
            const response: Nullable<NatBaseResponseInterface> = await props.asyncCallFunction(
                props.tokenRepo.registerTokenNoAuthenticationKey.bind(
                    props.tokenRepo, condominiumCd, mailAddress, mailAddressConfirm),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(props.eventEmitter)
                },
                {
                    defaultErrorTitle: Messages.EOPCR0016.toString(),
                    defaultErrorTitlePriority: true,
                    replacementDetailErrorMessages: [{
                        targetMessageId: Messages.EOPCA0004,
                        replacementMessageId: Messages.EOPCR0015
                    }]
                },
            )
            if (response && response.requestError === null) {
                props.navigate('/resident/noAuthenticationKey/mailSendComplete')
            }
        } finally {
            props.eventEmitter.closeLoading()
        }
    }

    return (<>
        <BlockSpacer height={'30px'}/>
        <NatResidentStepper
            stepList={[
                {label: '手続き説明'},
                {label: <>マンション・<BreakPcOnly/>メールアドレス登録</>, isActive: true},
                {label: 'メール受信'},
                {label: '申請者情報登録'},
                {label: '申請者情報確認'},
                {label: '申請提出完了', isSquare: true}
            ]}
        />
        <BlockSpacer height={'30px'}/>
        <PageTitle>
            マンション・メールアドレス登録
        </PageTitle>
        <Box height={'20px'}/>
        <HeadingAreaMessageComponentForResident eventEmitter={props.eventEmitter}/>
        <NatResidentCondominiumRegisterForm
            {...props}
            submitButtonLabel={'登録する'}
            onClickRegisterConfirmButton={onClickRegisterConfirmButton}
        />
        <Box mt={'30px'}/>
        <CenterPlainLinkStyledButton onClick={onClickBackLoginLink}>
            ログイン画面へ戻る
        </CenterPlainLinkStyledButton>
        <BlockSpacer height={'30px'}/>
    </>)
}
export default createResidentWithErrorHandlingPage(NatResidentCondominiumRegisterPage)
